import React from 'react';
import styled from 'styled-components'
import Avatar from '../../Components/Avatar';
import NormalText from '../../Components/NormalText';
import Button from '../../Components/Button';



export default({
    existUser,
    userData,
    onSubmit
})=>{
    if(existUser === false && userData !== null && userData !== false){
        // if(true){
        return(
        <form onSubmit={onSubmit}>
            <Wrapper>
                <ContentBox>
                    <AvatarBox>
                        <Avatar size={"lg"} url={userData.items[0].snippet.thumbnails.high.url} />
                        {/* <Avatar size={"lg"} url={"https://yt3.ggpht.com/a-/AOh14GiX4zNJW-Rxu5OiUYFVXTSKcvFcBLqYmf6eU6l4=s88-c-k-c0xffffffff-no-rj-mo"} /> */}
                    </AvatarBox>
                    <NickNameBox>
                        <SignColumn>
                            <SignText text={"닉네임"} />
                        </SignColumn>
                        <InputBox>
                            {/* <NormalText text={"테스트 닉네임"} /> */}
                            <NormalText text={userData.items[0].snippet.title} />
                        </InputBox>
                    </NickNameBox>
                    <ButtonBox>
                        <ConFirmButton text={"구글 계정으로 가입하기"} backgroundColor={"blue"}/>
                    </ButtonBox>
                </ContentBox>
            </Wrapper>
        </form>
        )
    }else{
        return null
    }
}
const Wrapper = styled.div`
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
    width:100%;
`

const ContentBox = styled.div`
    padding:20px;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    width: 50%;
`

const AvatarBox = styled.div`
    padding:30px;
`

const NickNameBox = styled.div`
    width:100%;
`

const SignColumn = styled.div`
    display:flex;
    align-items:flex-start;
    margin-bottom:5px;
`

const SignText = styled(NormalText)`
    color:${props => props.theme.cloudyColor};
`

const InputBox = styled.div`
    border:2px solid #dfe1e5;
    border-radius:5px;
    padding:10px;
`



const ButtonBox = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    width:100%;
    padding:30px;
`

const ConFirmButton = styled(Button)`

`